import styled from 'styled-components';

export const Container = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 48px 24px 64px;

  @media (max-width: 800px) {
    padding: 32px 16px 48px;
  }
`;

export const PageTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const Title = styled.h1`
  font-size: 22px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.shaft};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 12px;
`;

export const TitleAccent = styled.div`
  width: 48px;
  height: 2px;
  background: ${({ theme }) => theme.colors.gulfStream};
  margin: 0 auto;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  line-height: 1.6;
  ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.gray};
  text-align: center;
  margin: 0 0 24px;
`;

export const FormContainer = styled.form`
  padding: 8px 0;
  display: grid;
`;
